export default "__VITE_ASSET__D5dcV1fq__"